(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shava-cortes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shava-cortes')) {
    customElements.define('shava-cortes', class extends HTMLElement {
      connectedCallback() {
        const rotores = [...this.querySelectorAll('.shava-corte__rotor')].filter((r) => r.children.length > 1);
        if (!rotores.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let aLaVista = !('IntersectionObserver' in window);
        if (!aLaVista) {
          this.vigia = new IntersectionObserver(([e]) => { aLaVista = e.isIntersecting; });
          this.vigia.observe(this);
        }
        this.relojes = [];
        rotores.forEach((rot, i) => {
          this.relojes.push(setTimeout(() => {
            this.relojes.push(setInterval(() => {
              if (!aLaVista || document.hidden || rot.closest('.shava-corte').matches(':hover')) return;
              const hojas = rot.children;
              const n = (+rot.dataset.n + 1) % hojas.length;
              hojas[rot.dataset.n].classList.remove('on');
              hojas[n].classList.add('on');
              rot.dataset.n = n;
            }, 4000));
          }, i * 600));
        });
      }
      disconnectedCallback() {
        (this.relojes || []).forEach((r) => { clearTimeout(r); clearInterval(r); });
        if (this.vigia) this.vigia.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shava-portada"] && !Shopify.designMode) return;
  try {
    
  // Un latido cada 3 s y cada carrusel cambia en latidos alternos: cada foto dura 6 s y
  // los dos lados nunca cambian a la vez. Se detiene con la pestaña oculta, con el mouse
  // o el foco encima, y no arranca si la clienta pidió menos movimiento.
  if (!customElements.get('shava-portada')) {
    customElements.define('shava-portada', class extends HTMLElement {
      connectedCallback() {
        this.rotas = [...this.querySelectorAll('.shava-rota')];
        this.rotas.forEach((r) => {
          const ls = r.querySelectorAll('.shava-lamina');
          r.dataset.n = 0;
          const rayas = r.querySelector('.shava-rota__rayas');
          if (ls.length < 2) return;
          ls.forEach((l, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' de ' + ls.length);
            if (!i) b.setAttribute('aria-current', 'true');
            b.addEventListener('click', () => this.mostrar(r, i));
            rayas.append(b);
          });
        });
        this.latidos = 0;
        this.arrancar = this.arrancar.bind(this);
        document.addEventListener('visibilitychange', this.arrancar);
        this.arrancar();
      }
      disconnectedCallback() {
        clearInterval(this.reloj);
        document.removeEventListener('visibilitychange', this.arrancar);
      }
      arrancar() {
        clearInterval(this.reloj);
        if (document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.reloj = setInterval(() => {
          this.latidos += 1;
          if (this.latidos < 2) return;
          this.rotas.forEach((r) => {
            if (+r.dataset.fase !== this.latidos % 2 || !r.offsetParent || r.matches(':hover, :focus-within')) return;
            this.mostrar(r, +r.dataset.n + 1);
          });
        }, 3000);
      }
      mostrar(r, n) {
        const ls = r.querySelectorAll('.shava-lamina');
        if (ls.length < 2) return;
        n = (n + ls.length) % ls.length;
        ls.forEach((l, i) => {
          l.classList.toggle('on', i === n);
          if (i === n) { l.removeAttribute('tabindex'); l.removeAttribute('aria-hidden'); }
          else { l.setAttribute('tabindex', '-1'); l.setAttribute('aria-hidden', 'true'); }
          const img = l.querySelector('img');
          if (i === n && img && img.loading === 'lazy') img.loading = 'eager';
        });
        r.querySelectorAll('.shava-rota__rayas button').forEach((b, i) => {
          if (i === n) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
        r.dataset.n = n;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
